import React from 'react'
import { connect } from 'react-redux'
import { RouteComponentProps } from 'react-router'
import { withRouter } from 'react-router-dom'
import { TidewaysContext } from './app/context'
import Navigator from './app/navigator'
import { SERVICE_ALL, ServiceType } from './domain/Service'
import { parseQueryString } from './helper/queryString'
import { ServerCapability } from './helper/ServerCapability'
import CriticalTransactionsScene from './monitor/criticalTransactionsScene'
import EventNavigator from './monitor/events/navigator'
import Event from './monitor/events/view'
import ExternalCallsGraph from './monitor/external-calls-graph'
import ExternalOperations from './monitor/external-operations'
import Graph from './monitor/graph'
import MonitorNavigation from './monitor/monitor-navigation'
import { ApplicationState, isFeatureEnabled } from './redux/ApplicationState'
import { NavigationEntry } from './service-type-navigation'
import { UpgradeNecessary } from './upgrade'
import { AllServicesGraphs } from './monitor/all-services-graphs'

interface StateProps {
    tidewaysContext: TidewaysContext
    parameters: { [key: string]: string }
    navigator: Navigator
    type: string
    allServicesFeatureFlag: boolean
}

type Props = StateProps & RouteComponentProps

export class MonitorComponent extends React.Component<Props> {
    public render() {
        const { tidewaysContext, allServicesFeatureFlag } = this.props
        if (!tidewaysContext.application.license.monitoring) {
            return <UpgradeNecessary title={'Response Times'} featureName={'PHP Monitoring'} />
        }

        const route = 'XhprofOrganizationBundle.Application.show'
        const navigationEntries: NavigationEntry[] = [
            { label: 'PHP Performance', type: ServiceType.php, route },
            { label: 'External HTTP Calls', type: ServiceType.external, route },
        ]

        const serviceOverviewMode = tidewaysContext.route.parameters.view || 'grid'

        let showCriticalTransactions = true
        if (this.props.parameters.event) {
            showCriticalTransactions = false
        }
        if (tidewaysContext.service === SERVICE_ALL && serviceOverviewMode !== 'critical_transactions') {
            showCriticalTransactions = false
        }

        return (
            <div className="row">
                <div className="col-md-12">
                    <MonitorNavigation
                        navigationEntries={navigationEntries}
                        currentRoute={tidewaysContext.route}
                        showServiceOverviewModes={tidewaysContext.service === SERVICE_ALL}
                    />
                    {this.props.type === ServiceType.php && (
                        <>
                            {tidewaysContext.service === SERVICE_ALL && serviceOverviewMode !== 'critical_transactions' ? (
                                <AllServicesGraphs
                                    tidewaysContext={tidewaysContext}
                                    navigator={this.props.navigator}
                                    singleCol={serviceOverviewMode === 'single'}
                                />
                            ) : null}
                            {tidewaysContext.service !== SERVICE_ALL ? (
                                <div className="row">
                                    <div className="col-md-12 monitor application-graph jquery-tooltip-reference">
                                        <Graph responseType="95p" />
                                    </div>
                                </div>
                            ) : null}
                            {this.props.parameters.event ? (
                                <div className="row">
                                    <div>
                                        <div className="col-md-3">
                                            <EventNavigator />
                                        </div>
                                        <div className="col-md-9">
                                            <Event />
                                        </div>
                                    </div>
                                </div>
                            ) : null}
                            {showCriticalTransactions ? (
                                <div className="row">
                                    <div className="col-md-12 operation-list">
                                        <CriticalTransactionsScene />
                                    </div>
                                </div>
                            ) : null}
                        </>
                    )}
                    {this.props.type === ServiceType.external ? (
                        <div className="row">
                            <ServerCapability
                                level="warning"
                                checkForActivation
                                hideChildrenOnInactive={false}
                                capability={'HttpMonitoring'}
                            >
                                {tidewaysContext.service === SERVICE_ALL && serviceOverviewMode !== 'critical_transactions' ? (
                                    <AllServicesGraphs
                                        tidewaysContext={tidewaysContext}
                                        navigator={this.props.navigator}
                                        external
                                        singleCol={serviceOverviewMode === 'single'}
                                    />
                                ) : null}
                                {tidewaysContext.service !== SERVICE_ALL ? (
                                    <div className="col-md-12 monitor application-graph jquery-tooltip-reference">
                                        <ExternalCallsGraph responseType="95p" />
                                    </div>
                                ) : null}
                                {showCriticalTransactions ? (
                                    <div className="col-md-12 operation-list">
                                        <ExternalOperations />
                                    </div>
                                ) : null}
                            </ServerCapability>
                        </div>
                    ) : null}
                </div>
            </div>
        )
    }
}

export default withRouter(
    connect<StateProps, {}>((globalState: ApplicationState, props: RouteComponentProps) => ({
        tidewaysContext: globalState.tidewaysContext,
        parameters: parseQueryString(props.location.search),
        navigator: new Navigator(globalState.tidewaysContext.route),
        type: globalState.tidewaysContext.route.parameters.st ?? 'php',
        allServicesFeatureFlag: isFeatureEnabled(globalState, 'monitoring_all_services'),
    }))(MonitorComponent),
)
